<template>
    <div style="background-color:#e9e9e9; height: 100%">
        <!--    <div class="el-div"></div>-->
        <div class="header acea-row row-between-wrapper user-header-wd">
            <el-row class="user-row-wd">
                <el-col :span="6"
                ><img class="header-pictrue" :src="userInfo.avatar"/>
                </el-col>
                <el-col :span="1">
                    <div style="margin-top: 2vh;margin-left: 62vw">
                        <el-row>
                            <el-col :span="24">
                       <span
                               class="iconfont icon-shezhi user-setting"
                               @click="$router.push({ path: '/user/data' })"
                       ></span>
                            </el-col>
                        </el-row>
                    </div>
                </el-col>
                <el-col :span="7" :offset="1">
                    <div style="margin-top: 10vh;margin-left: 5vw">
                        <el-row>
                            <el-col :span="24">
                                <span style="color: #FFFFFF;font-size: larger">我的</span>
                            </el-col>
                        </el-row>
                    </div>
                </el-col>
            </el-row>
            <el-row style="width: 100%">
                <el-col :span="24" class="user-name">
                    {{ userInfo.nickname }}
                </el-col>
            </el-row>
            <el-row style="width: 100%">
                <el-col :span="24" class="my-league">
                    {{ userInfo.lastLeagueName }}
                </el-col>
            </el-row>
        </div>
        <!--    <div>-->
        <!--      <el-row class="score-row">-->
        <!--        <el-col :span="6" :offset="9">-->
        <!--          <div class="user-score">-->
        <!--            <span style="word-break: keep-all"-->
        <!--              >当前积分:{{ userInfo.integral || 0 }}</span-->
        <!--            >-->
        <!--          </div>-->
        <!--        </el-col>-->
        <!--      </el-row>-->
        <!--    </div>-->
        <!--    <div class="wrapper">
              <div class="nav acea-row row-middle">
                <div class="item">
                  <div>当前积分</div>
                  <div class="num">{{ userInfo.integral || 0 }}</div>
                </div>
              </div>
            </div>-->
        <div class="integra-box">
            <div style="margin: 5px">
                <el-divider class="integra-divider"></el-divider>
                <router-link :to="'/user/league'">
                    <span class="integra-title">组织选择</span>
                    <img class="integra-img" src="@assets/images/zzxz-2.png"/>
                    <i class="el-icon-arrow-right integra-jt"></i>
                </router-link>
                <el-divider class="integra-divider"></el-divider>
                <router-link :to="'/user/add_manageEj'">
                    <span class="integra-title">邮寄地址</span>
                    <img class="integra-img" src="@assets/images/yjdz-2.png"/>
                    <i class="el-icon-arrow-right integra-jt"></i>
                </router-link>
                <el-divider class="integra-divider"></el-divider>
                <router-link :to="'/order/orderEjList'">
                    <span class="integra-title">兑换记录</span>
                    <img class="integra-img" src="@assets/images/dhjl-2.png"/>
                    <i class="el-icon-arrow-right integra-jt"></i>
                </router-link>
                <el-divider class="integra-divider"></el-divider>
                <router-link :to="'/categoryEj/:pid?'">
                    <span class="integra-title">积分商城</span>
                    <img class="integra-img" src="@assets/images/jfsc-2.png"/>
                    <i class="el-icon-arrow-right integra-jt"></i>
                </router-link>
                <el-divider class="integra-divider"></el-divider>
            </div>
        </div>
        <div class="footer-line-height"></div>
        <SwitchWindow
                v-on:changeswitch="changeswitch"
                :switchActive="switchActive"
                :login_type="userInfo.login_type"
        ></SwitchWindow>
        <GeneralWindow
                :generalActive="generalActive"
                @closeGeneralWindow="closeGeneralWindow"
                :generalContent="generalContent"
        ></GeneralWindow>
    </div>
</template>

<script>
    import {getUser, userIntegraInfo} from "@api/user";
    import {isWeixin} from "@utils";
    import SwitchWindow from "@components/SwitchWindow";
    import GeneralWindow from "@components/GeneralWindow";
    import $store from "../../store";

    const NAME = "User";

    export default {
        name: NAME,
        components: {
            SwitchWindow,
            GeneralWindow
        },
        props: {},
        data: function () {
            return {
                userInfo: {},
                MyMenus: [],
                orderStatusNum: {},
                switchActive: false,
                isWeixin: false,
                generalActive: false,
                generalContent: {
                    promoterNum: "",
                    title: ""
                },
                userIntegraInfoData: {
                    uid: 0,
                    loginIntegra: 0,
                    loginIntegraPercentage: 0,
                    currentLessonIntegra: 0,
                    currentLessonIntegraPercentage: 0,
                    previousLessonIntegra: 0,
                    previousLessonIntegraPercentage: 0,
                    articleIntegra: 0,
                    articleIntegraPercentage: 0,
                    testIntegra: 0,
                    testPercenIntegra: 0
                }
            };
        },
        watch: {
            $route(n) {
                if (n.name === NAME) this.User();
            }
        },
        mounted: function () {
            this.User();
            this.isWeixin = isWeixin();
            this.getUserIntegraInfo();
        },
        methods: {
            changeswitch: function (data) {
                this.switchActive = data;
            },
            User: function () {
                let that = this;
                getUser().then(res => {
                    try {
                        that.userInfo = res.data;
                        that.orderStatusNum = res.data.orderStatusNum;
                        this.generalContent = {
                            promoterNum: `您在商城累计消费金额仅差 <span style="color: #ff8500;">${res
                                .data.promoter_price || 0}元</span>即可开通推广权限`,
                            title: "您未获得推广权限"
                        };
                    } catch (e) {
                        $store.commit("LOGOUT");
                    }
                });
            },
            getUserIntegraInfo: function () {
                let that = this;
                userIntegraInfo().then(res => {
                    console.log(res);
                    that.userIntegraInfoData = res;
                });
            },
            goPages: function (index) {
                let url = this.MyMenus[index].wap_url;
                if (url === "/user/user_promotion") {
                    if (!this.userInfo.is_promoter && this.userInfo.statu == 1)
                        return this.$dialog.toast({mes: "您还没有推广权限！！"});
                    if (!this.userInfo.is_promoter && this.userInfo.statu == 2) {
                        return (this.generalActive = true);
                    }
                }
                if (url === "/customer/index" && !this.userInfo.adminid) {
                    return this.$dialog.toast({mes: "您还不是客服！！"});
                }
                this.$router.push({path: this.MyMenus[index].wap_url});
            },
            closeGeneralWindow(msg) {
                this.generalActive = msg;
            },
        },
    };
</script>

<style scoped>
    .footer-line-height {
        height: 1rem;
    }

    .order-status-num {
        min-width: 0.33rem;
        background-color: #fff;
        color: #ee5a52;
        border-radius: 15px;
        position: absolute;
        right: -0.14rem;
        top: -0.15rem;
        font-size: 0.2rem;
        padding: 0 0.08rem;
        border: 1px solid #ee5a52;
    }

    .header-pictrue {
        margin-left: 42vw;
        margin-top: 16vh;
        position: relative;
        border-radius: 50%;
        width: 15vw;
        padding: 2px;
        border: 1px solid #000;
        -moz-box-shadow: 3px 3px 4px #000;
        -webkit-box-shadow: 3px 3px 4px #000;
        box-shadow: 3px 3px 4px #000;
        background: #fff;
        filter: progid:DXImageTransform.Microsoft.Shadow(Strength=4, Direction=135, Color='#000000');
    }

    .switch-h5 {
        margin-left: 0.2rem;
    }

    .user-binding {
        padding: 0.05rem 0.2rem;
        background-color: #003eab;
        border-radius: 50px;
        font-size: 0.24rem;
        border: 1px solid #0997f7;
        color: #ffffff;
    }

    .xxpd_bg {
        text-align: center;
        /*background-image: linear-gradient(-180deg, #f86d6d 0%, #ff2323 100%);*/
        /*background-image: radial-gradient(circle, #f86d6d, #ff2323);*/
        background-image: url("../../assets/images/classChannel/wd.jpg");
        /*background-repeat: no-repeat;*/
        background-size: 100% 100%; /*按比例缩放*/
        height: 100%;
    }

    .user-header-wd {
        background-image: url("../../assets/images/userEjHeader.png");
        height: 23vh;
        width: 100%;
        position: relative;
        text-align: center;
        background-size: 100% 100%; /*按比例缩放*/
    }

    .picTxt {
        width: 100%;
    }

    .user-row-wd {
        width: 100%;
    }

    .user-name {
        width: 100%;
        text-align: center;
        font-size: large;
        color: #000000;
        display: inline;
    }

    .setting-col {
        height: 15vh;
        margin-top: 5vh;
    }

    .user-setting {
        color: #e5e5e5;
        font-size: xx-large;
    }

    .user-score {
        font-size: larger;
        color: #e5e5e5;
        display: inline;
    }

    .score-row {
        margin-top: 1vh;
        background-image: url("../../assets/images/score-bar.png");
        background-size: contain;
        background-repeat: no-repeat;
        background-color: #66c5f5;
        background-position: center;
        height: 5vh;
    }

    .last-img {
        height: 35vh;
        width: 100%;
        position: relative;
        text-align: center;
        background-size: 100% 100%; /*按比例缩放*/
        background-image: url("../../assets/images/classChannel/2.jpg");
        margin: 0px;
    }

    .el-div {
        width: 100% !important;
        height: 12vh !important;
        text-align: center !important;
        background-size: 100% 100% !important; /*按比例缩放*/
        background-image: url("../../assets/images/classChannel/xxpd-tou.jpg");
    }

    .integra-box {
        border: 0px solid #ebebeb;
        border-radius: 3px;
        transition: 0.2s;
        background-color: #fafafa;
        width: 100%;
        margin-top: 14vh;
    }

    .integra-progress {
        margin-top: 3vh;
        margin-bottom: 1vh;
    }

    .integra-title {
        font-weight: bold;
    }

    .integra-text {
        margin-left: 10px;
        font-weight: lighter;
    }

    .integra-img {
        float: left;
        margin-left: 5vw;
        width: 7vw;
    }

    .integra-jt {
        float: right;
        margin-right: 5vw;
        font-size: large;
        font-weight: normal;
    }

    .my-league {
        width: 100%;
        text-align: center;
        font-size: medium;
        color: #000000;
        display: inline;
    }
</style>
